import { TableSelectionEvent } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { AutogenLayoutMarketAreaList } from "./autogen/AutogenLayoutMarketAreaList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class MarketAreaList extends AutogenLayoutMarketAreaList {

    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override onLoad() {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
    }

    async tableMarketAreaListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.MarketArea, this.tableMarketAreaList.selectedRow);
    }

}
